import utils from '../../utils/tag-name';

const TAG_NAME = utils.constructTagName('staticradio');

export { TAG_NAME };
